export function highlightYellow(s: string | number) {
    return `<span class="wrapper" style="background-color: rgb(241, 196, 15);" data-mce-style="background-color: #f1c40f;">${s}</span>`;
}
